<template>
    <footer class="footer_new">
        <div class="footer_new_content">
            <div class="footer_new_column footer_new_columnFirst">
                <div class="footer_new_infoBlock">
                    <span>© 2013 &mdash; {{ currentYear }}, Export-base</span>
                    <span class="footer_new_languages">
                    <div class="footer_new_languagesBlock">
                        <span>
                            <a href="/" target="_blank">
                                <img src="./img/rus.png" alt="Русский язык" width="16" height="12"/>
                            </a>
                        </span>
                        <span class="footer_new_engLanguage">
                            <a href="https://export-base.net/" target="_blank">
                        <img src="./img/usa.png" alt="Английский язык" width="16" height="12"/>
                    </a>
                        </span>
                    </div>
                    <div class="footer_new_arrowBlock">
                        <span class="footer_new_arrowDownWhite"></span>
                    </div>
                </span>
                </div>
                <div class="footer_new_phone_num_span">Поддержка: <a href="tel:+78007752912">8 (800) 775-29-12</a></div>
                <div>
                    <a class="footer_new_mailLink" href="mailto:info@export-base.ru"
                       target="_blank">info@export-base.ru
                    </a>
                </div>
                <div>
                    <a href="mailto:info@export-base.ru" target="_blank">
                        <img src="./img/question.png" height="52" width="250" alt="Ответим на ваши вопросы"/>
                    </a>
                </div>
                <a href="https://vk.com/exportbase" target="_blank" class="footer_new_vk">Группа в ВК</a>
            </div>
            <div class="footer_new_column">
                <div class="footer_new_list">
                    <div class="footer_new_listImg">
                        <img src="./img/key_yellow.png" width="16" height="15" alt="Личный кабинет"/>
                    </div>
                    <div class="footer_new_firstAndSecondBlock">
                        <div class="footer_new_firstBlock">
                            <h2><b>EXPORT BASE</b></h2>
                            <a href="https://export-base.ru/auth" target="_blank" class="boldText footer_new_privateCabinet">Личный кабинет</a>
                            <a href="https://export-base.ru/#" target="_blank">База предприятий</a>
                            <a href="https://export-base.ru/new" target="_blank">База новых компаний из ФНС</a>
                            <a href="https://export-base.ru/okved" target="_blank">База ЕГРЮЛ/ИП</a>
                            <a href="https://export-base.ru/import_export" target="_blank">База импорт/экспорт(ВЭД)</a>
                            <a href="https://export-base.ru/geo_locator" target="_blank">База по районам городов</a>
                            <a href="https://export-base.ru/suppliers" target="_blank">База поставщиков</a>
                            <a href="https://export-base.ru/api_service" target="_blank">Доступ по API</a>
                        </div>
                        <div class="footer_new_secondBlock">
                            <a href="https://call.export-base.ru/otzyvy_i_kejsy_o_koll_export_base"
                               target="_blank">Отзывы о ExportBase
                            </a>
                            <a href="https://export-base.ru/metody_prodvigenia_kompanii" target="_blank">
                                Методы продвижения
                            </a>
                            <a href="https://export-base.ru/privacy_policy" target="_blank">
                                Политика конфиденциальности
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer_new_column footer_new_columnThird">
                <h2><b>ДРУГИЕ СЕРВИСЫ EXPORTBASE</b></h2>
                <div class="footer_new_firstBlockColumnThird">
                    <a href="https://export-base.ru/dop_uslugi/sbor_bazy_po_inn" target="_blank">
                        Актуализация вашей базы ИНН/ОГРН
                    </a>
                    <a href="https://export-base.ru/inn_search" target="_blank">Найти компании по ИНН/ОГРН</a>
                </div>
                <div>
                    <a href="https://promo.export-base.ru/" target="_blank">Рассылка e-mail</a>
                    <a href="https://mail.export-base.ru/" target="_blank">Валидация ваших e-mail</a>
                </div>
                <div>
                    <a href="https://map.export-base.ru/" target="_blank">Тепловая карта жилой застройки</a>
                    <a href="https://export-base.ru/site_parsing" target="_blank">Парсинг сторонних сайтов</a>
                </div>
                <div>
                    <a href="https://call.export-base.ru/" target="_blank">Call-центр &mdash; звонковый центр</a>
                    <a href="https://reddial.ru/" target="_blank">Reddial &mdash; онлайн база и CRM</a>
                    <a href="https://export-base.ru/chrome_widget" target="_blank">Виджет ExportBase для Chrome</a>
                </div>
            </div>
            <div class="footer_new_column footer_new_columnFourth">
                <slot></slot>
            </div>
        </div>
    </footer>

</template>

<script>

export default {
    name: 'Footer',

    computed: {
        currentYear() {
            return (new Date()).getFullYear();
        },
    },

};

</script>

<style src="./css/reset.css" scoped></style>

<style scoped>
    .footer_new {
        width: 100%;
        background-color: #353535;
        margin-top: 3%;
        font-size: 14px;
        letter-spacing: -0.1px;
        line-height: 12px;
    }

    .footer_new_content {
        width: 100%;
        max-width: 1160px;
        margin: 2.1% auto;
        justify-content: space-between;
    }

    .footer_new_column {
        margin: 0 1%;
    }

    .footer_new_column h2 {
        margin-bottom: 20px;
    }

    .footer_new_columnFirst div {
        margin: 3% 0;
    }

    .footer_new_languages {
        padding-left: 3%;
    }

    .footer_new_languagesBlock {
        flex-direction: column;
    }

    .footer_new_languages, .footer_new_languagesBlock {
        display: inline-flex;
    }

    .footer_new_languages a, a.footer_new_tel {
        text-decoration: none;
    }

    .footer_new_languages:hover .footer_new_engLanguage {
        display: inline;
    }

    .footer_new_engLanguage {
        display: none;
    }

    .footer_new a, .footer_new {
        color: white;
    }

    .footer_new_firstAndSecondBlock a, a.footer_new_vk, .footer_new_columnThird a, a.footer_new_addNewCompany {
        text-decoration: none;
        color: #ccc;
    }

    .footer_new_firstAndSecondBlock a:hover, .footer_new_vk:hover, .footer_new_columnThird a:hover,
    a.footer_new_addNewCompany:hover {
        text-decoration: underline;
        color: #f3f3f3;
    }

    a.footer_new_mailLink {
        color: #60B6eA;
        font-size: 14px;
        font-weight: bold;
    }

    .footer_new_list, .footer_new_content, .footer_new {
        display: flex;
    }

    .footer_new_firstBlock, .footer_new_secondBlock, .footer_new_firstAndSecondBlock,
    .footer_new_columnThird div, .footer_new_column {
        display: flex;
        flex-direction: column;
    }

    .footer_new_secondBlock a, .footer_new_firstBlock a,.footer_new_columnThird a, .footer_new_columnFourth a {
        margin-bottom: 13px;
    }

    .footer_new_columnThird div {
        margin: 0.68em 0;
    }

    div.footer_new_firstBlockColumnThird {
        margin: 0 0 0.75em 0;
    }

    .footer_new_secondBlock, .footer_new_columnFourth a.footer_new_addNewCompany {
        margin-top: 1.25em;
    }

    .footer_new_listImg {
        margin: 29px 3% 0 0;
    }

    .footer_new_dashed  span{
        border-bottom: 1px dashed white;
        cursor: pointer;
    }

    .footer_new_vk {
        display: inline;
        align-self: flex-start;
        background: url("./img/vk-logo.png") no-repeat 0 0;
        height: 20px;
        padding: 0.45em 0 0 15%;
        margin-top: 6em;
    }

    .footer_new_arrowDownWhite {
        display: inline-block;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-top: 3px solid #fff;
    }

    div.footer_new_arrowBlock {
        margin: -0.1em 0 0 0.5em;
    }

    div.footer_new_infoBlock {
        height: 20px;
    }

    div.footer_new_infoBlock {
        margin-top: 0;
    }

    .footer_new_phone_num_span {
        line-height: 20px;
    }

    .footer_new_phone_num_span a {
        text-decoration: none;
    }

    @media (max-width: 800px) {
        .footer_new_columnFourth {
            display: none;
        }

        .footer_new_column:first-child {
            margin: 0 2% 0 15px;
        }

        .footer_new_column {
            margin: 0 2%;
        }
    }
</style>
